import { render, staticRenderFns } from "./PidAdvancedUploadFormat.vue?vue&type=template&id=5b9cc4bf&scoped=true&"
import script from "./PidAdvancedUploadFormat.vue?vue&type=script&lang=js&"
export * from "./PidAdvancedUploadFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9cc4bf",
  null
  
)

export default component.exports